import { Component, ComponentFactoryResolver, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { Models } from '@ibexfusion/models';
import { SnackbarService } from '@services/snackbar/snackbar.service';
import { ImportTypeService } from '@services/import-types/import-type.service';
import { FormDirective } from '../../../directives/form/form.directive';
import { PageAction } from '../../../components/page-actions/page-actions.component';
import { DefaultFormComponent } from '../../../components/default-form/default-form.component';
import { FormComponent } from '../../../components/default-form/form.component';

@Component({
    selector: 'app-import-types-create',
    templateUrl: './import-types-create.component.html',
    styleUrls: ['./import-types-create.component.scss'],
    providers: [ImportTypeService],
    standalone: false
})
export class ImportTypesCreateComponent implements OnInit {

  @ViewChild(FormDirective, { static: true }) formHost: FormDirective;

  pageActions: PageAction[];
  title = 'Create import type';
  isLoading = true;
  boundImportType: Models.ImportType;

  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private importTypeService: ImportTypeService,
    private activatedRoute: ActivatedRoute,
    private snackbar: SnackbarService
  ) {
  }

  ngOnInit() {
    const importTypeId = this.activatedRoute.snapshot.params['id'];

    this.boundImportType = <Models.ImportType>Models.ModelFactory.createModelInstanceByName('ImportType');
    this.isLoading = false;
    this.loadForm();
    this.isLoading = false;
  }

  loadForm() {
    const formItem = DefaultFormComponent;

    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(formItem);

    const viewContainerRef = this.formHost.viewContainerRef;
    viewContainerRef.clear();

    const componentRef = viewContainerRef.createComponent(componentFactory);
    (<FormComponent>componentRef.instance).entry = this.boundImportType;
  }

  onSave() {
    return this.boundImportType.validate(true).then(result => {
      if (result.success) {
        this.importTypeService.create(this.boundImportType).then(importTypeResult => {
          console.log(importTypeResult);
        });
      } else {
        this.snackbar.open('Could not create the import type, please fill the form correctly');
      }
    });
  }
}
